/**
 * @generated SignedSource<<1dfdca6d76ffb97ba092193c47b66a0f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContemporaryLandingRespLayout_viewer$data = {
  readonly contemporaryLanding: {
    readonly modules: ReadonlyArray<{
      readonly type?: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"ContemporaryLandingCategoriesModule_contemporaryLandingRow" | "ContemporaryLandingFeaturedModule_contemporaryLandingRow" | "ContemporaryLandingFurnitureTileModule_contemporaryLandingRow" | "ContemporaryLandingMakersModule_contemporaryLandingRow" | "ContemporaryLandingProductsModule_contemporaryLandingRow" | "ContemporaryLandingSplashHeaderModule_contemporaryLandingSplashHeader" | "ContemporaryLandingStyleModule_contemporaryLandingRow" | "ContemporaryLandingTextHeaderModule_contemporaryLandingHeader" | "ContemporaryLandingVideoModule_contemporaryLandingVideo">;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "ContemporaryLandingRespLayout_viewer";
};
export type ContemporaryLandingRespLayout_viewer$key = {
  readonly " $data"?: ContemporaryLandingRespLayout_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContemporaryLandingRespLayout_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v1 = [
  (v0/*:: as any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "contemporaryLandingPreviewId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContemporaryLandingRespLayout_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "rootId",
          "variableName": "contemporaryLandingPreviewId"
        }
      ],
      "concreteType": "ContemporaryLanding",
      "kind": "LinkedField",
      "name": "contemporaryLanding",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "modules",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ContemporaryLandingTextHeaderModule_contemporaryLandingHeader"
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*:: as any*/),
              "type": "ContemporaryLandingHeader",
              "abstractKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ContemporaryLandingSplashHeaderModule_contemporaryLandingSplashHeader"
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*:: as any*/),
              "type": "ContemporaryLandingSplashHeader",
              "abstractKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ContemporaryLandingStyleModule_contemporaryLandingRow"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ContemporaryLandingProductsModule_contemporaryLandingRow"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ContemporaryLandingFeaturedModule_contemporaryLandingRow"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ContemporaryLandingMakersModule_contemporaryLandingRow"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ContemporaryLandingVideoModule_contemporaryLandingVideo"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ContemporaryLandingCategoriesModule_contemporaryLandingRow"
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*:: as any*/),
              "type": "ContemporaryLandingVideo",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ContemporaryLandingFurnitureTileModule_contemporaryLandingRow"
                },
                (v0/*:: as any*/)
              ],
              "type": "ContemporaryLandingRow",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "7e69d9fc9ef5a82e6107b78323730228";

export default node;
